<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-12-11 15:27:07
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$lang('绑定MFA设备')"
    top="10vh"
    width="904px"
    @close="close"
    :visible.sync="visible"
    >
    <main class="dialog_main">
      <section class="header_step">
        <el-steps :space="300" :active="stepActive" align-center >
          <el-step :title="$lang('获取应用')"></el-step>
          <el-step :title="$lang('绑定设备')"></el-step>
          <el-step :title="$lang('完成')"></el-step>
        </el-steps>
      </section>
      <section class="step_content">
        <transition name="component-fade" mode="out-in">
          <component
            :is="componentId"
            :googleInfo="googleInfo"
            :checkErr="checkErr"
            @codeSuccess="verifyCodeSuccess"
            @success="stepSuccess"
            />
        </transition>
      </section>
    </main>
    <section class="footer_btn">
      <el-button @click="close" v-if="componentId !== 'StepThree'">{{ $lang(cancelBtnText) }}</el-button>
      <el-button type="primary" @click="stepNext" v-if="componentId !== 'StepThree'" :loading="nextStepLoading">{{ $lang(confirmBtnText) }}</el-button>
    </section>
  </el-dialog>
</template>
<script>
import StepOne from './stepOne.vue'
import StepTwo from './stepTwo.vue'
import StepThree from './stepThree.vue'
import * as Api from '@api/base/public'

export default {
  components: {
    StepOne,
    StepTwo,
    StepThree
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    googleInfo: {
      type: Object,
      default: () => {}
    }
  },
  name: 'BindDeviceDialog',
  data() {
    return {
      stepActive: 1,
      componentId: 'StepOne',
      confirmBtnText: '已安装，下一步',
      cancelBtnText: '取消',
      verifyCode: '',
      nextStepLoading: false,
      bindSuccessData: {},
      checkErr: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    verifyCodeSuccess(code) {
      this.verifyCode = code
    },
    close() {
      this.$emit('update:visible', false)
      Object.assign(this.$data, this.$options.data())
    },
    stepSuccess() {
      this.$emit('bindSuccess', this.bindSuccessData)
    },
    async validCode() {
      try {
        if (!this.verifyCode) {
          this.$message.error(this.$lang('请输入验证码'))
          return
        }
        this.nextStepLoading = true
        this.checkErr = false
        const params = {
          account: this.googleInfo.account,
          googleTwoFactorValidateToken: this.googleInfo.googleTwoFactorValidateToken,
          code: this.verifyCode
        }
        const res = await Api.checkGoogleTwoFactor(params)
        this.nextStepLoading = false
        if (res.code === 1) {
          this.btnText('StepThree', '上一步', '下一步', 3)
          this.bindSuccessData = res
        } else {
          res.code === 149000017 && (this.checkErr = true)
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log('🚀 ~ file: BindDeviceDialog.vue:97 ~ validCode ~ error:', error)
      }
    },
    btnText(componentId, cancelBtnText, confirmBtnText, stepActive) {
      this.componentId = componentId
      this.cancelBtnText = cancelBtnText
      this.confirmBtnText = confirmBtnText
      this.stepActive = stepActive
    },
    stepNext() {
      const actions = new Map([
        ['StepOne', () => { this.btnText('StepTwo', '取消', '已安装，下一步', 2) }],
        ['StepTwo', () => { this.validCode() }],
        ['StepThree', () => { this.$emit('bindSuccess', this.bindSuccessData) }]
      ])
      const action = actions.get(this.componentId) || actions.get('StepOne')
      action.call(this)
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
 .dialog_main{
  .header_step{
    margin-bottom:10px;
  }
  .step_content{
    background: #f8f8f8;
    border-radius: 12px;
  }
}
.footer_btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 42px;
}
 .fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active for below version 2.1.8 */
  {
  opacity: 0;
}
</style>
